<div class="wp-game-list">
  <h3 class="wp-game-list__title">
    {{ title() }}
    <span class="wp-game-list__count">({{ totalCount() }})</span>
  </h3>

  <div class="wp-game-list__toolbar">
    <mat-form-field appearance="outline" class="wp-game-list__search" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        type="search"
        placeholder="Search…"
        [attr.data-id]="'wageringProfileSearch_' + listKey()"
        [ngModel]="filterValue()"
        (ngModelChange)="applyFilter($event)" />
      @if (filterValue()) {
        <button mat-icon-button matSuffix type="button" (click)="clearFilter()" aria-label="Clear search">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    @if (editMode()) {
      <button
        mat-stroked-button
        color="accent"
        type="button"
        [attr.data-id]="'wageringProfileAdd_' + listKey()"
        (click)="add.emit()">
        <mat-icon>add</mat-icon>
        Add game
      </button>
    }
  </div>

  <div class="wp-game-list__table-wrap">
    <table mat-table [dataSource]="dataSource" class="wp-game-list__table">
      <ng-container matColumnDef="logo">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="wp-game-list__logo-cell">
          @if (logoSrc(row); as src) {
            <img [src]="src" class="wp-game-list__logo" />
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Game</th>
        <td mat-cell *matCellDef="let row">{{ row.gameInstance?.name }}</td>
      </ng-container>
      <ng-container matColumnDef="provider">
        <th mat-header-cell *matHeaderCellDef>Provider</th>
        <td mat-cell *matCellDef="let row">{{ row.gameInstance?.provider || row.gameInstance?.studioName }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            color="warn"
            type="button"
            matTooltip="Remove"
            [attr.data-id]="'wageringProfileRemove_' + listKey()"
            (click)="remove.emit(row)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell wp-game-list__empty" [attr.colspan]="displayedColumns().length">No games</td>
      </tr>
    </table>
  </div>

  @if (showPaginator()) {
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
  }
</div>
